<template>
    <button
        v-if="page != 'elipsis'"
        class="pagination-button page-number"
        :class="{ current: iscurrent }"
        @click="$emit('changePage', page)"
    >
        {{ page }}
    </button>
    <div v-else class="elipsis">...</div>
</template>

<script>
export default {
    props: ['page', 'iscurrent', 'elipsis'],
    name: 'page-button',
};
</script>
